"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SCREEN_WIDE = exports.SCREEN_TABLET = exports.SCREEN_NORMAL = exports.SCREEN_MOBILE = exports.SCREEN_HUGE = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DEFAULT_SCREEN_MOBILE = 0;
var DEFAULT_SCREEN_TABLET = 768;
var DEFAULT_SCREEN_NORMAL = 992;
var DEFAULT_SCREEN_WIDE = 1240;
var DEFAULT_SCREEN_HUGE = 2000;
var SCREEN_MOBILE = 'SCREEN_MOBILE';
exports.SCREEN_MOBILE = SCREEN_MOBILE;
var SCREEN_TABLET = 'SCREEN_TABLET';
exports.SCREEN_TABLET = SCREEN_TABLET;
var SCREEN_NORMAL = 'SCREEN_NORMAL';
exports.SCREEN_NORMAL = SCREEN_NORMAL;
var SCREEN_WIDE = 'SCREEN_WIDE';
exports.SCREEN_WIDE = SCREEN_WIDE;
var SCREEN_HUGE = 'SCREEN_HUGE';
exports.SCREEN_HUGE = SCREEN_HUGE;
var defaultValue = {
  screenSizes: {
    SCREEN_MOBILE: DEFAULT_SCREEN_MOBILE,
    SCREEN_TABLET: DEFAULT_SCREEN_TABLET,
    SCREEN_NORMAL: DEFAULT_SCREEN_NORMAL,
    SCREEN_WIDE: DEFAULT_SCREEN_WIDE,
    SCREEN_HUGE: DEFAULT_SCREEN_HUGE
  },
  imageStyles: {
    SCREEN_MOBILE: 'small',
    SCREEN_TABLET: 'small',
    SCREEN_NORMAL: 'medium',
    SCREEN_WIDE: 'large',
    SCREEN_HUGE: 'large'
  }
};

var ViewportContext = /*#__PURE__*/_react.default.createContext(defaultValue);

var _default = ViewportContext;
exports.default = _default;